import { jsx } from "react/jsx-runtime";
import { useServicesMultiChoiceOptions } from "../utils/use-services-multi-choice-options.js";
import { CheckboxGroupFieldWUT } from "../../../ui/checkbox-group-field/checkbox-group-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ServicesMultiChoiceWUT = (props) => {
  const fieldType = FIELD_TYPES.SERVICES_MULTI_CHOICE;
  const { options, isEmpty, shouldRender } = useServicesMultiChoiceOptions(props);
  if (!props.isEditor && isEmpty) {
    return null;
  }
  if (!shouldRender) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    CheckboxGroupFieldWUT,
    {
      ...props,
      fieldType,
      value: props.value || [],
      options
    }
  );
};
export {
  ServicesMultiChoiceWUT
};
//# sourceMappingURL=services-multi-choice-wut.js.map
